import React, {PropTypes} from 'react';
import Error from './Error';

const Errors = ({errors}) => {
  const errorsCollection = errors.map(error => {
    return (<Error error={error.message} key={error.message}/>);
  });
  return (
    <div className="errors-container">
      {errorsCollection}
    </div>
  );
};

Errors.propTypes = {
  errors: PropTypes.array.isRequired
};

export default Errors;



/** WEBPACK FOOTER **
 ** ./src/components/common/Errors.js
 **/